import { prop, inject, ComponentEventBus } from "fw";
import { Form } from "fw-model";

@inject
export class TextFormField {
    @prop(null) public form!: Form;
    @prop(null) public field;
    @prop(null) public label!: string;
    @prop(null) public type!: "date" | "email" | "tel" | "text" | "password" | "number" | "url";
    @prop(null) public setfocus;
    @prop(null) public readonly;
    @prop(false) public disabled;
    @prop(null) public floatingLabel;
    @prop(null) public autocomplete;
    @prop(null) public placeholder;

    private name = "";

    constructor(private ceb: ComponentEventBus) {}

    public attached() {
        this.formChanged();
    }

    private formChanged() {
        this.name = this.form && this.form.getFieldName ? this.form.getFieldName(this.field) : this.field;
    }

    private onChange() {
        this.ceb.dispatch("change");
    }
    private onKeyUp() {
        this.ceb.dispatch("keyup");
    }
}
